import { form, AppendixForm } from "./form";
const checkout = form;
const checkoutAppendix = AppendixForm;
const {
  formField: {
    certificate,
    fullName,
    firstTime,
    signer,
    supplementaryForThe,
    date,
    taxAgencyName,
    period,
    resolutions,
    dividends,
    profits,
    taxId,
    taxId2,
    taxpayerName,
    timeSign,
    taxAgentContract,
    conpanyName,
  },
} = checkout;

const { dateAppendix, taxpayerNameAppendix, taxIdAppendix, profitsAppendix, revenueAppendix } =
  checkoutAppendix;

const initialValues = {
  [certificate.name]: "",
  [fullName.name]: "",
  [firstTime.name]: false,
  [signer.name]: "",
  [supplementaryForThe.name]: "",
  [conpanyName.name]: "",
  [date.name]: "",
  [taxAgencyName.name]: "",
  [period.name]: "",
  [resolutions.name]: "",
  [profits.name]: "",
  [dividends.name]: "",
  [taxId.name]: "",
  [taxId2.name]: "",
  [taxpayerName.name]: "",
  [timeSign.name]: "",
  [taxAgentContract.name]: "",
  //appendix
  // [dateAppendix.name]: "",
  // [taxpayerNameAppendix.name]: "",
  // [taxIdAppendix.name]: "",
  // [profitsAppendix.name]: "",
  // [revenueAppendix.name]: "",
};

export default initialValues;
